import { React, useState } from 'react';

import Box from '@mui/material/Box';
import SolarPowerRoundedIcon from '@mui/icons-material/SolarPowerRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';

import InserirGeracaoBulk from '../../components/atualizarGeracaoBulk';
import InserirGeracaoIndividual from '../../components/atualizarGeracaoIndividual';
import PageHeader from '../../components/pageHeader';
import SettaSwitch from '../../components/settaSwitch';
import '../css/generationEntry.css';

const InserirGeracao = () => {
    const [tipo, setTipo] = useState('individual');
    const isBulk = tipo === 'bulk';

    return (
        <Box className='mainBox generation-entry-page'>
            <PageHeader>{isBulk ? 'Inserir Geração CSV' : 'Inserir Geração'}</PageHeader>

            <Box className='generation-entry-mode-panel'>
                <Box className='generation-entry-mode-copy'>
                    {isBulk ? <TableChartRoundedIcon /> : <SolarPowerRoundedIcon />}
                    <Box>
                        <span>Modo de lançamento</span>
                        <strong>{isBulk ? 'Envio por CSV' : 'Inserção individual'}</strong>
                    </Box>
                </Box>

                <Box className='generation-entry-mode-switch'>
                    <span>Individual</span>
                    <SettaSwitch
                        checked={isBulk}
                        onChange={(checked) => setTipo(checked ? 'bulk' : 'individual')}
                        ariaLabel='Alternar entre inserção individual e CSV'
                    />
                    <span>CSV</span>
                </Box>
            </Box>

            {isBulk ? <InserirGeracaoBulk /> : <InserirGeracaoIndividual /> }
        </Box>
    );
};

export default InserirGeracao;
